const exporter = async (rows, name) => {
  try {
    const filename = `${name}.csv`

    const processRow = row => {
      const finalVal = []
      for (const col of row) {
        if (
          col === '' ||
          col === undefined ||
          col === null ||
          Number.isNaN(col)
        ) {
          finalVal.push('')
        } else if (typeof col === 'string') {
          let escaptedCol = col.replace(/"/g, '""')
          if (escaptedCol.search(/("|,|\n)/g) > -1) {
            escaptedCol = `"${escaptedCol}"`
          }
          finalVal.push(escaptedCol)
        } else finalVal.push(col)
      }

      return finalVal.join(',') + '\n'
    }

    let csvFile = ''
    for (var i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i])
    }

    const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' })
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename)
    } else {
      const link = document.createElement('a')
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', filename)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  } catch (error) {
    // console.log(error)
    return error
  }
}

export default {
  exporter
}
